module.exports = {"SB_TITLE":"Maintenance books"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/service-book/sb.en.json
// module id = 2cUk
// module chunks = 0